var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_2543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 6.25V0H2.375C1.06331 0 0 1.04932 0 2.34375V22.6562C0 23.9502 1.06331 25 2.375 25H16.625C17.9367 25 19 23.9507 19 22.6562V7.8125H12.7112C11.7909 7.8125 11.0833 7.11426 11.0833 6.25ZM4.75 10.9375C5.6243 10.9375 6.33333 11.6372 6.33333 12.5C6.33333 13.3628 5.62578 14.0625 4.75 14.0625C3.87422 14.0625 3.16667 13.3643 3.16667 12.5C3.16667 11.6357 3.8757 10.9375 4.75 10.9375ZM15.7393 21.46C15.6008 21.7188 15.3336 21.875 15.0417 21.875H3.95833C3.66641 21.875 3.39823 21.7164 3.26018 21.4624C3.19258 21.3377 3.16053 21.1973 3.16746 21.0561C3.17438 20.9149 3.22003 20.7782 3.29952 20.6606L5.93824 16.7543C6.04141 16.5381 6.2888 16.4062 6.59557 16.4062C6.90234 16.4062 7.10768 16.5368 7.25414 16.7542L7.91667 17.7344L10.1605 14.4126C10.3065 14.1943 10.5539 14.0625 10.8211 14.0625C11.0883 14.0625 11.3332 14.1931 11.4797 14.4104L15.7017 20.6604C15.863 20.8984 15.8779 21.2061 15.7393 21.46ZM12.6667 0V6.25H19L12.6667 0Z",
    fill: "#FF9D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_2543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.72515e8dc15fdf00822fbfb4bdfe6506.svg";
export { ForwardRef as ReactComponent };